























import Vue from "vue";

export default Vue.extend({
  name: "SupportModalSuccess",

  props: {
    email: {
      type: String,
      required: true,
    },
  },
});
